import Immutable from 'immutable';
import { createSelector } from 'reselect';

const currentFinesIds = state => state.getIn(['borrowing', 'fines', 'results'], Immutable.List());
const finesEntities = state => state.getIn(['entities', 'fines'], Immutable.Map());

export const getFines = createSelector(
  [finesEntities, currentFinesIds],
  (fines, fineIds) => fines.filter(
    fine => fineIds.includes(fine.get('id'))
  )
);


export default {
  getFines
};



// WEBPACK FOOTER //
// ./app/selectors/FinesSelector.js